import type { Lang } from "../lib/types";
import { useDrawOn } from "../lib/useMotion";

// 워드마크 (디자인 핸드오프). EN/JP 모두 인라인 SVG path(흰색 스트로크) — PNG 미사용.
const BWEK_VIEWBOX = "60 30 720 320";
const BWEK_PATH =
  "M 98 58 C 100 130, 105 195, 106 240 C 107 300, 178 306, 196 258 C 208 228, 188 196, 150 198 C 116 200, 104 230, 122 252 C 140 264, 166 268, 188 280 C 200 264, 210 232, 220 214 C 232 248, 244 280, 252 292 C 262 280, 276 246, 288 214 C 300 246, 314 280, 324 292 C 334 280, 348 244, 360 216 C 392 214, 420 214, 448 214 C 474 214, 478 176, 442 162 C 404 148, 366 172, 368 212 C 370 250, 398 284, 438 282 C 468 280, 492 270, 516 260 C 545 266, 575 270, 598 250 C 598 180, 598 110, 598 58 C 599 108, 600 150, 600 188 L 678 116 L 602 192 L 694 300";

// ブェック (일본어 워드마크) — 핸드오프 JP_LOGO 그룹.
const JP_VIEWBOX = "0 0 780 270";
const JP_GROUPS: { transform?: string; paths: string[] }[] = [
  {
    paths: [
      "M38,88 C78,52 160,52 194,68 C216,77 202,128 162,170 C137,196 116,214 96,236",
      "M200,50 C209,65 215,78 224,98",
      "M236,45 C245,60 252,73 261,94",
    ],
  },
  {
    transform: "rotate(-2 320 178)",
    paths: ["M286,150 C308,146 340,148 358,154", "M323,151 C325,170 323,190 319,207", "M282,207 C308,202 344,202 364,208"],
  },
  {
    paths: ["M392,160 C397,169 401,178 406,189", "M420,156 C426,166 430,175 435,187", "M470,152 C463,178 440,205 394,224"],
  },
  {
    paths: ["M566,72 C554,85 542,98 528,116", "M552,67 C598,60 644,63 658,73 C684,88 666,142 612,182 C585,204 560,218 542,234"],
  },
];

interface Props {
  lang: Lang;
  height?: number;
  stroke?: number;
  draw?: boolean;
  className?: string;
}

export default function Logo({ lang, height = 28, stroke = 26, draw = false, className }: Props) {
  const ref = useDrawOn<SVGSVGElement>(draw, 2100);
  const common = {
    fill: "none" as const,
    stroke: "#fff",
    strokeWidth: stroke,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };

  if (lang === "ja") {
    return (
      <svg
        ref={ref}
        viewBox={JP_VIEWBOX}
        role="img"
        aria-label="ブェック"
        preserveAspectRatio="xMidYMid meet"
        style={{ height, width: "auto", display: "block" }}
        className={className}
      >
        {JP_GROUPS.map((g, gi) => (
          <g key={gi} transform={g.transform} {...common}>
            {g.paths.map((d, i) => (
              <path key={i} data-draw d={d} />
            ))}
          </g>
        ))}
      </svg>
    );
  }

  return (
    <svg
      ref={ref}
      viewBox={BWEK_VIEWBOX}
      role="img"
      aria-label="bwek"
      preserveAspectRatio="xMidYMid meet"
      style={{ height, width: "auto", display: "block" }}
      className={className}
    >
      <path data-draw d={BWEK_PATH} {...common} />
    </svg>
  );
}
